<template>
  <div class="backdrop"></div>
</template>

<script>
export default {
  name: 'backdrop',
  data: function () {
    return {}
  },
  async mounted () {
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// backdrop.vue?49fa4038